import { render } from "./MainVideo.vue?vue&type=template&id=37db6298&scoped=true"
import script from "./MainVideo.vue?vue&type=script&lang=js"
export * from "./MainVideo.vue?vue&type=script&lang=js"

import "./MainVideo.vue?vue&type=style&index=0&id=37db6298&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37db6298"]])

export default __exports__